'use strict';
import {mapPropsStream} from 'recompose';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {AssetProjectCardListView} from './AssetProjectCardListView';


export const StreamedComponent = (props$) => {
  const list$ = props$
    .distinctUntilChanged(isListOrFilterChanged)
    .map(props =>
      !props.list || props.list.length === 0
        ? props.list
        : props.list
          .filter(model => getId(model) !== props.filterId)
    );

  return props$
    .combineLatest(
      list$,
      (props, list) => ({
        ...props,
        list,
      }));
};

export const AssetProjectCardListComponent = mapPropsStream(StreamedComponent)(AssetProjectCardListView);

function isListOrFilterChanged(a, b) {
  if (!a && !b) {
    return true;
  } else if (!a || !b) {
    return false;
  } else if ((!a.list || a.list.length === 0) && (!b.list || b.list.length === 0)) {
    return true;
  } else {
    return (
      a.filterId === b.filterId
      && a.list === b.list
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/components/AssetProjectCardList/AssetProjectCardListComponent.js